export const PACKED_DUTY_VERSION = 1;
export const PACKED_UNASSIGNED = 4294967295;
export const SHIFT_FLAG_OFF = 1 << 0;
export const SHIFT_FLAG_NIGHT = 1 << 1;
export const SHIFT_PATTERN_SHIFT = 8;
export const SHIFT_PATTERN_MASK = 0xff << SHIFT_PATTERN_SHIFT;
export const SHIFT_PATTERN = {
    OTHER: 0,
    DAY: 1,
    EVENING: 2,
    NIGHT: 3,
    OFF: 4,
};
export const RULE_FLAG_FORBIDDEN_PATTERNS = 1 << 0;
export const RULE_FLAG_AVOIDANCE_PATTERNS = 1 << 1;
export const RULE_FLAG_PONGDANG_PATTERNS = 1 << 2;
/** Opt-in exact work/night limits; absence preserves the organization generator boundary. */
export const RULE_FLAG_EXACT_CONSECUTIVE_LIMITS = 1 << 3;
export const PACKED_RULE_INDEX = {
    MAX_CONSECUTIVE_DAYS: 0,
    MAX_CONSECUTIVE_NIGHTS: 1,
    FLAGS: 2,
    LENGTH: 3,
};
export class PackedInputError extends Error {
    constructor(code, message) {
        super(message);
        this.name = "PackedInputError";
        this.code = code;
    }
}
export class GpuExecutionError extends Error {
    constructor(code, message, candidateIndex) {
        super(message);
        this.name = "GpuExecutionError";
        this.code = code;
        this.candidateIndex = candidateIndex;
    }
}
//# sourceMappingURL=types.js.map